import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: '',
    service: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d6accktt1k61917cmnu0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          message: '',
          service: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-[#FF6B35] font-semibold text-sm uppercase tracking-wider">Kontakt</span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2F4858] mt-4 mb-6">
            Starten Sie jetzt mit professioneller E-Commerce Buchführung
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Vereinbaren Sie ein kostenloses Erstgespräch und erfahren Sie, wie wir Ihr E-Commerce Unternehmen optimal aufstellen und beim Wachstum unterstützen können.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100">
            <h3 className="text-2xl font-bold text-[#2F4858] mb-6">Kontaktformular</h3>
            
            <form onSubmit={handleSubmit} data-readdy-form id="contact-form">
              <div className="space-y-5">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all text-sm"
                    placeholder="Ihr vollständiger Name"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    E-Mail *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all text-sm"
                    placeholder="ihre@email.de"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    Telefon
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all text-sm"
                    placeholder="+49 123 456789"
                  />
                </div>

                <div>
                  <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">
                    Unternehmen
                  </label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all text-sm"
                    placeholder="Ihr Unternehmensname"
                  />
                </div>

                <div>
                  <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-2">
                    Interessiert an
                  </label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={(e) => setFormData({ ...formData, service: e.target.value })}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all text-sm"
                  >
                    <option value="">Bitte wählen...</option>
                    <option value="ecommerce">Unverbindliches Erstgespräch</option>
                    <option value="international">Angebotsanfrage</option>
                    <option value="amazon">Fehler auf der Webseite</option>
                    <option value="other">Sonstiges</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                    Nachricht *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows={4}
                    maxLength={500}
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all resize-none text-sm"
                    placeholder="Beschreiben Sie kurz Ihr Anliegen... (max. 500 Zeichen)"
                  />
                  <div className="text-xs text-gray-500 mt-1 text-right">
                    {formData.message.length}/500 Zeichen
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full px-8 py-4 bg-[#FF6B35] text-white font-semibold rounded-lg hover:bg-[#e55a2a] transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {isSubmitting ? 'Wird gesendet...' : 'Nachricht senden'}
                </button>

                {submitStatus === 'success' && (
                  <div className="p-4 bg-green-50 border border-green-200 rounded-lg text-green-800 text-sm">
                    <i className="ri-checkbox-circle-line mr-2"></i>
                    Vielen Dank! Wir melden uns zeitnah bei Ihnen.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-red-800 text-sm">
                    <i className="ri-error-warning-line mr-2"></i>
                    Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.
                  </div>
                )}
              </div>
            </form>
          </div>

          {/* Contact Information */}
          <div className="space-y-8">
            <div className="bg-gradient-to-br from-[#2F4858] to-[#1e2f3a] rounded-2xl p-8 text-white shadow-xl">
              <h3 className="text-2xl font-bold mb-6">Kontaktinformationen</h3>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#FF6B35] flex-shrink-0">
                    <i className="ri-mail-line text-2xl"></i>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-semibold mb-1">E-Mail</h4>
                    <a href="mailto:service@hommen-consulting.de" className="text-white/90 hover:text-[#FF6B35] transition-colors">
                      service@hommen-consulting.de
                    </a>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#FF6B35] flex-shrink-0">
                    <i className="ri-phone-line text-2xl"></i>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-semibold mb-1">Telefon</h4>
                    <a href="tel:+4912345678" className="text-white/90 hover:text-[#FF6B35] transition-colors">
                      +49 (176) 316 69 010
                    </a>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#FF6B35] flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl"></i>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-semibold mb-1">Adresse</h4>
                    <p className="text-white/90">
                      HOMMEN Consulting GmbH<br />
                      Westring 32<br />
                      41379 Brüggen<br />
                      Deutschland
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#FF6B35] flex-shrink-0">
                    <i className="ri-time-line text-2xl"></i>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-semibold mb-1">Öffnungszeiten</h4>
                    <p className="text-white/90">
                      Mo - Fr: 9:00 - 18:00 Uhr<br />
                      Sa - So: Geschlossen
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="mt-24 border-t border-gray-200 pt-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div className="col-span-1 md:col-span-2">
              <img 
                src="https://static.readdy.ai/image/535cd5cb202604744f94f7b2225e7be8/507ad711238d1ff66498f69658d73c1b.png"
                alt="HOMMEN Consulting"
                className="h-10 mb-4"
              />
              <p className="text-gray-600 text-sm leading-relaxed">
                Ihr spezialisierter Partner für E-Commerce Accounting, Controlling und Tax Compliance. Wir unterstützen Onlinehändler bei Wachstum und internationaler Expansion mit fundierter Expertise und modernen Lösungen.
              </p>
            </div>
            <div>
              <h4 className="font-bold text-[#2F4858] mb-4">Services</h4>
              <ul className="space-y-2 text-sm text-gray-600">
                <li><a href="#services" className="hover:text-[#FF6B35] transition-colors cursor-pointer">E-Commerce Beratung</a></li>
                <li><a href="#solutions" className="hover:text-[#FF6B35] transition-colors cursor-pointer">Amazon FBA</a></li>
                <li><a href="#solutions" className="hover:text-[#FF6B35] transition-colors cursor-pointer">Shopify Integration</a></li>
                <li><a href="#benefits" className="hover:text-[#FF6B35] transition-colors cursor-pointer">Compliance</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-[#2F4858] mb-4">Rechtliches</h4>
              <ul className="space-y-2 text-sm text-gray-600">
                <li><Link to="/impressum" className="hover:text-[#FF6B35] transition-colors cursor-pointer">Impressum</Link></li>
                <li><Link to="/datenschutz" className="hover:text-[#FF6B35] transition-colors cursor-pointer">Datenschutz</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-600">
            <p>© 2025 HOMMEN Consulting GmbH. Alle Rechte vorbehalten.</p>
            <p className="mt-4 md:mt-0">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF6B35] transition-colors">
                Powered by Readdy
              </a>
            </p>
          </div>
        </div>
      </footer>
    </section>
  );
}